<template>
  <div>
    <el-upload
      ref="upload"
      action=""
      class="avatar-uploader"
      style="display: inline-block;line-height: 0;margin: 0 8px 8px 0;"
      :class="{ 'plus-hidden': fileList.length >= limit}"
      accept="image/*"
      :show-file-list="false"
      :file-list="fileList"
      :http-request="uploadSectionFile">
      <i
        class="el-icon-plus avatar-uploader-icon"
        :style="plusStyle"></i>
    </el-upload>
    <ul
      v-if="fileList.length"
      style="display: inline-block;line-height: 0;"
      class="el-upload-list el-upload-list--picture-card">
      <li
        v-for="(item, index) in fileList"
        :key="index"
        tabindex="0"
        :style="plusStyle"
        class="el-upload-list__item is-success">
        <img
          style="object-fit: contain;"
          :src="item.url"
          class="el-upload-list__item-thumbnail">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview">
            <i
              class="el-icon-zoom-in"
              @click="handlePictureCardPreview(item)"></i>
          </span>
          <span class="el-upload-list__item-delete">
            <i
              class="el-icon-delete"
              @click="handleRemove(index)"></i>
          </span>
        </span>
      </li>
    </ul>
    <div
      v-if="showTip"
      class="el-upload__tip"
      style="margin-top:0">只能上传jpg/png文件，最多{{ limit }}张，且每张不超过{{ isLt2M }}kb</div>
    <cropper-modal
      v-if="cropper"
      :visible="visible"
      :img="img"
      :loading="loading"
      :fixedNumber="fixedNumber"
      :autoCropWidth="autoCropWidth"
      :autoCropHeight="autoCropHeight"
      @crop:cancel="cropCancel"
      @crop:submit="cropSubmit"></cropper-modal>
    <el-dialog
      :visible.sync="previewVisible"
      width="600px"
      append-to-body>
      <img
        width="100%"
        :src="previewUrl">
    </el-dialog>
  </div>
</template>

<script>
import CropperModal from './cropper-modal.vue'
export default {
  name: 'UploadWithCrop',
  components: { CropperModal },
  props: {
    showTip: { type: Boolean, default: true },
    value: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    limit: {
      type: Number,
      default: 1
    },
    cropper: {
      type: Boolean,
      default: false
    },
    fixedNumber: {
      type: Array,
      default() {
        return [1, 1]
      }
    },
    autoCropWidth: {
      type: Number,
      default: 200
    },
    autoCropHeight: {
      type: Number,
      default: 200
    },
    isLt2M: {
      type: Number,
      default: 2048
    }
  },
  data() {
    return {
      loading: false,
      previewVisible: false,
      previewUrl: '',
      visible: false,
      img: null
    }
  },
  computed: {
    plusStyle() {
      return { width: this.autoCropWidth + 'px', height: this.autoCropHeight + 'px', lineHeight: this.autoCropHeight + 'px' }
    },
    fileList: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    cropCancel() {
      this.visible = false
    },
    cropSubmit(file) {
      console.dir(file)
      const a = new FileReader()
      a.readAsDataURL(file.file)
      a.onload = function(e) {
        console.log(e.target.result)
      }
      this.uploadFile(file.file)
    },
    uploadSectionFile({ file }) {
      const isLt2M = file.size / 1024 < this.isLt2M
      if (!isLt2M) {
        this.$message.error(`上传图片大小不能超过 ${this.isLt2M}kb!`)
        return
      }
      if (this.cropper) {
        const img = new Image()
        img.src = URL.createObjectURL(file)
        img.onload = () => {
          const ratio = this.fixedNumber[0] / this.fixedNumber[1]
          if (img.width / img.height !== ratio) {
            this.$message.error(`图片推荐宽高比例为${this.fixedNumber[0]}:${this.fixedNumber[1]}`)
            setTimeout(() => {
              this.visible = true
              this.img = URL.createObjectURL(file)
            }, 500)
          } else {
            this.uploadFile(file)
          }
        }
      } else {
        this.uploadFile(file)
      }
    },
    uploadFile(file) {
      this.loading = true
      const form = new FormData()
      form.append('file', file)
      this.$store.dispatch('account/uploadfile', {
        payload: form,
        success: res => {
          this.fileList.push({
            url: res.data.viewUrl + res.data.filepath,
            name: file.name
          })
          this.loading = false
          this.cropCancel()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleRemove(index) {
      this.fileList.splice(index, 1)
    },
    handlePictureCardPreview(item) {
      this.previewUrl = item.url
      this.previewVisible = true
    }
  }
}
</script>
<style lang="stylus">
.plus-hidden {
  .el-upload {
    display: none;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
</style>
